const not_authenticated_en = require('./not_authenticated.json')
export default not_authenticated_en